<template>
    <div>
        <navigation/>
        <!--Banner Wrap Start-->
			<div class="iner_banner">
				<div class="container">
					<h5>Contact Us</h5>
					<div class="banner_iner_capstion">
						<ul>
							<li><router-link to="/">Home</router-link></li>
							<li><router-link to="/partners">Contact Us</router-link></li>
						</ul>
					</div>
				</div>
			</div>
            <!--Banner Wrap End-->
            <!--Iqoniq Content Start-->
			<div class="iq_content_wrap">
				<!--contact START-->
				<section class="about-us-section">
					<div class="container">
						<div class="row">
							<div class="col-12">
								<div class="text container" style="text-align:left">
									<!--Heading Wrap Start-->
			                    	<div class="iq_heading_1 text-left">
			                            <h4>Get <br> <span>In Touch</span></h4>
			                        </div>
			                        <!--Heading Wrap End-->
                                    <div class="address row">
                                        <div class="col-md-4 address-grid">
                                            <div class="address-info">
                                                <div class="address-left text-center">
                                                    <i class="fa fa-map"></i>
                                                </div>
                                                <div class="address-right text-center">
                                                    <h6 class="ad-info text-uppercase mb-2">Address</h6>
                                                    <p>  Block A2-5 suite 62 Shopping complex, Simpson street, Lagos Island Nigeria</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="col-md-4 address-grid">
                                            <div class="address-info">
                                                <div class="address-left text-center">
                                                    <i class="fa fa-envelope"></i>
                                                </div>
                                                <div class="address-right text-center">
                                                    <h6 class="ad-info text-uppercase mb-2">Email</h6>
                                                        <a href="info@leniveauedu.com"> info@leniveauconsult.com </a>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-md-4 address-grid">
                                            <div class="address-info">
                                                <div class="address-left text-center">
                                                    <i class="fa fa-phone"></i>
                                                </div>
                                                <div class="address-right text-center ">
                                                    <h6 class="ad-info text-uppercase mb-2">Phone</h6>
                                                    <p>+2348033370339 | +2348099523015</p>

                                                </div>
                                            </div>
                                        </div>
		                            </div>
								</div>
							</div>
						</div>
					</div>
                    <div class=" row py-5 ">
                                    <div class="col-md-6">
                                        <div id="mapouter">
                                            <div id="gmap_canvas"><iframe width="600" height="500" frameborder="0" scrolling="no" marginheight="0" src="https://maps.google.com/maps?q=Sura Shopping complex, Simpson street, Lagos Island, &amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=&amp;output=embed" marginwidth="0"></iframe><a class="addmaps" href="http://www.embedgooglemap.net" id="get-map-data">Block A2-5 suite 62 Shopping complex, Simpson street, Lagos Island Nigeria </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 ">
                                        <div class="bg-img">
                                            <div class="contact-layer">
                                                <h5 class="mb-3">
                                                    Our customer service line is always available from Monday through Friday. 8:00am - 5:00pm (GMT+1).
                                                    Dont hesitate to contact us for any kind of information</h5>
                                                <p><i class="fa mr-2 fa-phone"></i>+2348033370339 | +2348099523015
</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
				</section>
				<!--contact End-->
            </div>
			<!--Iqoniq Content End-->
        <footers/>
    </div>
</template>
<script>
import navigation from './navigation.vue'
import footers from './footer.vue'
export default {
    name: 'contact',
    components:{
        navigation, footers
    }
}
</script>
<style>

/* #gmap_canvas {
    height:500px;
    width:600px;
} */
/* #mapouter{
    overflow:hidden;
    height:500px;
    width:600px;

    } */
    /*-- contact --*/
.bg-img {
    background: url('../assets/extra-images/contact.jpg') no-repeat center;
    background-size: cover;
}
.contact-layer {
    background: rgba(0, 0, 0, 0.5);
    padding: 10em 4em;
    height: 100%;
}
.py-5{
    margin-top:15px
}
.bg-img h5 {
    font-size: 25px;
    color: #eee;
    font-weight: 350;
    text-transform: capitalize;
    line-height: 50px;
}
.bg-img p i{
    color: #c9a63c;
}
.bg-img p{
    margin: 0;
    font-size: 26px;
    font-weight: 600;
    color: #eee;
}


.address-info {
	padding: 1em 2em;
}
.address-right h6 {
    font-size: 17px;
    color: #777777;
    letter-spacing: 2px;
    font-weight: 600;
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.07);
}

.address-grid i {
    font-size: 2em;
    color: #c9a63c;
    margin-bottom: 15px;
    margin-top: 15px
}

.address-right p,
.address-right a {
	color: #7c848c;
}
.map iframe {
    width: 100%;
    min-height: 300px;
}

</style>
